import React from 'react';
import PropTypes from 'prop-types';

import TemplateDefault from '../../templates/default/default';
import LandingStage from '../../organisms/landing-stage/landingStage';
import AnchorMenu from '../../molecules/anchor-menu/anchorMenu';
import LandingTeaser from '../../organisms/landing-teaser/landingTeaser';
import ContentBlocks from '../../organisms/content-blocks/contentBlocks.withRedux';

const Entry = ({ data, blogTeaser, anchorLinks }) => {
  return (
    <TemplateDefault invertedHeader backgroundGradient>
      {anchorLinks && <AnchorMenu links={anchorLinks} />}
      <LandingStage />
      <ContentBlocks noShareLinks />
      {blogTeaser && blogTeaser?.teasers?.length > 0 ? (
        <LandingTeaser
          teasers={blogTeaser.teasers}
          headline={blogTeaser.headline}
          linkText={blogTeaser.linkText}
          linkTo={blogTeaser.linkTo}
        />
      ) : null}
    </TemplateDefault>
  );
};

Entry.propTypes = {
  data: PropTypes.shape({
    type: PropTypes.string.isRequired
  }),
  blogTeaser: PropTypes.shape({
    headline: PropTypes.string,
    teasers: PropTypes.arrayOf(PropTypes.shape()),
    linkText: PropTypes.string,
    linkTo: PropTypes.string
  }),
  anchorLinks: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      label: PropTypes.string
    })
  )
};

export default Entry;
